import { SVGProps, Ref, forwardRef } from 'react';

export const BubbleSquareOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path d="M7 7.5v1.8h10V7.5z" fill="currentColor" />
            <path d="M15 11.5H7v1.8h8z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.002 9.998v.004L1 10v13l6.15-3.191c1.323.143 2.92.191 4.85.191 9.625 0 11-1.187 11-9.5C23 2.188 21.625 1 12 1 3.726 1 1.549 1.877 1.1 7.403a36 36 0 0 0-.098 2.595M2.8 20.038V10.25l.002-.234c.014-1.941.12-3.31.365-4.308.233-.953.562-1.439.953-1.756.43-.349 1.147-.665 2.47-.872C7.91 2.873 9.655 2.8 12 2.8c2.395 0 4.161.076 5.49.292 1.328.216 2.027.544 2.443.903.385.333.716.857.943 1.897.235 1.079.324 2.546.324 4.608s-.089 3.53-.324 4.608c-.227 1.04-.558 1.564-.943 1.897-.416.359-1.115.687-2.443.903s-3.095.292-5.49.292c-1.912 0-3.432-.048-4.655-.18l-.54-.06z"
                fill="currentColor"
            />
        </g>
    </svg>
));
BubbleSquareOutlinedSize24Glyph.displayName = 'BubbleSquareOutlinedSize24Glyph';
